import { ReactElement, useState } from 'react';

import { toYearMonth } from '~/utils/date/date';
import { IMedicaidPlanClient } from '~/services/api/medicaidPlan/types';

import ActivePlanMonth from './ActivePlanMonth';
import MonthBar from './MonthBar';

import styles from './PlanEngagement.module.scss';

interface IActivePlanEngagementProps {
  client: IMedicaidPlanClient;
}

const ActivePlanEngagement = ({ client }: IActivePlanEngagementProps): ReactElement => {
  const [selected, setSelected] = useState(() => toYearMonth(new Date()));

  return (
    <div className={styles.section}>
      <MonthBar selected={selected} onChange={setSelected} />
      <ActivePlanMonth
        key={`${selected.year}-${selected.month}`}
        client={client}
        selected={selected}
      />
    </div>
  );
};

export default ActivePlanEngagement;
